import { render } from "./SiteMetadataDatabasesComponent.vue?vue&type=template&id=0fa79cb8"
import script from "./SiteMetadataDatabasesComponent.vue?vue&type=script&lang=js"
export * from "./SiteMetadataDatabasesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__